// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';
import { Checkbox, Text, View } from 'reshaped';

import { setCartOwnerIsReseller } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useCartSummaryContext } from 'src/Layout/context/CartSummary';
import { useModalContext } from 'src/Layout/context/Modal';
import { useApplyOrgaProductOwner } from 'src/Reshaped/hooks/useApplyOrgaProductOwner';

export type Props = {
  checked: boolean,
  setChecked: React.ReactSetStateFunction<boolean>,
  disabled?: boolean,
};

export function CheckboxContact({
  checked,
  setChecked,
  disabled = false,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const dispatch = useDispatch();

  const { isReseller, cartOwnerOrganization, setFrozen } =
    useCartSummaryContext();

  const { openModal } = useModalContext();

  const [isChanging, setIsChanging] = React.useState(false);

  const applyOrgaProductOwner = useApplyOrgaProductOwner({
    onSuccess: undefined,
  });

  const handleChange = async ({
    checked: newChecked,
  }: {
    checked: boolean,
  }) => {
    setIsChanging(true);
    if (newChecked) {
      try {
        setFrozen(true);
        if (cartOwnerOrganization?.id)
          await applyOrgaProductOwner(cartOwnerOrganization.id);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        // pass
      } finally {
        setFrozen(false);
      }
    } else {
      // XXX: Maybe move this part into a useEffect
      // that will allow to have the same behavior
      // where the from the checked is unticked
      openModal({
        type: isReseller ? 'customerSelectModal' : 'ownerSelectModal',
        replace: true,
      });
    }

    // User just decided himself
    // that he wants or not to have same contact
    // for product owner and cart owner.
    // Then do no force this value.
    dispatch(setCartOwnerIsReseller(null));

    setChecked(newChecked);

    setIsChanging(false);
  };

  return (
    <View padding={4} paddingInline={1}>
      <Checkbox
        name="productOwner"
        checked={checked}
        // $FlowFixMe[incompatible-type]
        // $FlowFixMe[prop-missing]
        onChange={handleChange}
        disabled={disabled || isChanging}
      >
        <Text variant="body-2">{__('Owner details are the same')}</Text>
      </Checkbox>
      {cartOwnerOrganization?.reseller && (
        <View paddingStart={7}>
          <Text as="p" variant="caption-1" color="neutral-faded">
            {__(
              'I am purchasing products that are managed by and belong to my reseller organization.',
            )}
          </Text>
        </View>
      )}
    </View>
  );
}
